import { z } from 'zod';

// Remember to update turbo.json with the new environment variable for correct caching
export const clientSideEnvSchema = z.object({
  NEXT_PUBLIC_MAPBOX_TOKEN: z.string(),
  NEXT_PUBLIC_MAPBOX_USERNAME: z.string(),
  NEXT_PUBLIC_MAPBOX_LIGHTMODE_STYLE: z.string(),
  NEXT_PUBLIC_MAPBOX_DARKMODE_STYLE: z.string(),

  NEXT_PUBLIC_SENTRY_DSN: z.string().min(1),

  NEXT_PUBLIC_VERCEL_ENV: z.enum(['production', 'preview', 'development']),

  NEXT_PUBLIC_VERCEL_GIT_PULL_REQUEST_ID: z
    .literal('')
    .transform(() => undefined)
    .or(z.coerce.number().int())
    .optional(),
});

export const clientSideEnv = clientSideEnvSchema.parse({
  NEXT_PUBLIC_MAPBOX_USERNAME: process.env.NEXT_PUBLIC_MAPBOX_USERNAME,
  NEXT_PUBLIC_MAPBOX_TOKEN: process.env.NEXT_PUBLIC_MAPBOX_TOKEN,
  NEXT_PUBLIC_MAPBOX_LIGHTMODE_STYLE: process.env.NEXT_PUBLIC_MAPBOX_LIGHTMODE_STYLE,
  NEXT_PUBLIC_MAPBOX_DARKMODE_STYLE: process.env.NEXT_PUBLIC_MAPBOX_DARKMODE_STYLE,

  NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,

  NEXT_PUBLIC_VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV,

  NEXT_PUBLIC_VERCEL_GIT_PULL_REQUEST_ID: process.env.NEXT_PUBLIC_VERCEL_GIT_PULL_REQUEST_ID,
} satisfies Record<keyof z.infer<typeof clientSideEnvSchema>, unknown>);
